const API_BASE_PATH = '/signing-authority-assertions'

const SIGNING_AUTHORITY_ASSERTIONS = {
  LIST: `${API_BASE_PATH}`
}

export default SIGNING_AUTHORITY_ASSERTIONS
